import { gsap } from 'gsap'
import { ExpoScaleEase } from "gsap/EasePack"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { setupTimeline} from './utilities/audio-timeline-setup'
import LocomotiveScroll from 'locomotive-scroll'

gsap.registerPlugin(ExpoScaleEase);


let scroll = new LocomotiveScroll({
  el: document.querySelector('.smooth-scroll'),
  smooth: true,
  smoothMobile: true,
  lerp: 0.05
});

scroll.on("scroll", ScrollTrigger.update);

ScrollTrigger.scrollerProxy(".smooth-scroll", {
  scrollTop(value) {
    return arguments.length ? scroll.scrollTo(value, 0, 0) : scroll.scroll.instance.scroll.y;
  },
  getBoundingClientRect() {
    return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
  },
  pinType: document.querySelector(".smooth-scroll").style.transform ? "transform" : "fixed"
});


let timelineAnimation = setupTimeline()

$('.mobile-swipe-animation').removeClass('d-none')

const myST = ScrollTrigger.create({
  animation: timelineAnimation.timeline,
  trigger: "#audio-timeline",
  scroller: '.smooth-scroll',
  scrub: true,
  pin: true,
  start: "top top",
  end: "+="+(timelineAnimation.timeHeight),
  onUpdate: self => {},
  //markers: true
});


ScrollTrigger.addEventListener("refresh", () => scroll.update());
ScrollTrigger.refresh(true);

